import { Map } from 'immutable';

import { updateListingScore } from '../product/score';
import { keepOld } from '../iterable/keepOld';

import { AI_OPERATION, ATTRIBUTE_TO_DESTINATION, DESTINATION_TO_ATTRIBUTE } from '../../constants/ai';
import { PROFILE_TYPE, SECTIONS } from '../../constants/profiles';
import { ATTRIBUTE } from '../../constants/attributes';
import { VALUE } from '../../constants/product';
import { EMPTY } from '../../constants';
import { FORM } from '../../constants/forms';

export function shapeAiOperationsForApp({ operations }) {
  function reduceOperations(aiState, { destination_field: destination, input: { instructions = '' }, operation }) {
    const attribute = DESTINATION_TO_ATTRIBUTE[destination] || destination;
    return aiState.set(attribute, Map({ instructions, operation }));
  }

  return operations.reduce(reduceOperations, EMPTY.MAP);
}

export function shapeAiOperationsForAPI({ state }) {
  function reduceAttributes(operations, value, attribute) {
    if (!value.get('operation')) return operations;

    const operation = {
      destination_field: ATTRIBUTE_TO_DESTINATION[attribute] || attribute,
      input: {},
      operation: value.get('operation'),
    };

    if (value.get('instructions')) {
      operation.input.instructions = value.get('instructions');
    }

    operations.push(operation);

    return operations;
  }

  return state.reduce(reduceAttributes, []);
}

export function updateProfileProduct({ channel, product: initial, profile }) {
  let product = initial;

  for (const section of SECTIONS[channel][PROFILE_TYPE.AI]) {
    if (profile.hasIn([section, 'generated'])) {
      switch (section) {
        case FORM.TAGS: {
          switch (profile.getIn([section, 'operation'])) {
            case AI_OPERATION.ADD_MAXIMUM: {
              product = product.setIn([section, VALUE],
                product
                  .getIn([section, VALUE])
                  .mergeWith(keepOld, profile.getIn([section, 'generated']))
              );

              break;
            }

            default: {
              product = product.setIn([section, VALUE], profile.getIn([section, 'generated']));
              break;
            }
          }

          break;
        }

        case FORM.SEO: {
          if (profile.getIn([ATTRIBUTE.META_DESCRIPTION, 'generated'])) {
            product = product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE],
              profile.getIn([ATTRIBUTE.META_DESCRIPTION, 'generated'])
            );
          }

          if (profile.getIn([ATTRIBUTE.PAGE_TITLE, 'generated'])) {
            product = product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE],
              profile.getIn([ATTRIBUTE.PAGE_TITLE, 'generated'])
            );
          }

          break;
        }

        default: {
          product = product.setIn([section, VALUE], profile.getIn([section, 'generated']));
          break;
        }
      }

    }
  }

  return product;
}

export function updateProfileScore({ channel, product, profile, titleFormatPreference }) {
  return updateListingScore(updateProfileProduct({ channel, product, profile }), { titleFormatPreference }).get('score');
}
